var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-feature"},[_c('div',{staticClass:"portal-feature-toolbar"},[_c('router-link',{staticClass:"btn btn-ghost btn-sm",attrs:{"to":_vm.backLink}},[_vm._v(_vm._s(_vm.backLabel))])],1),_c('section',{staticClass:"portal-feature-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }